import React, { useCallback, useEffect, useState } from 'react';
import './Form.css';
import { useTelegram } from "../../hooks/useTelegram";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Button, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DeleteIcon from '@mui/icons-material/Delete';


const Form = () => {
    const [object, setObject] = useState('');
    const [objectNew, setObjectNew] = useState('');
    const [objectAll, setObjectAll] = useState([]);

    const [contract, setContract] = useState('');
    const [contractNew, setContractNew] = useState('');
    const [contractAll, setContractAll] = useState([]);

    const [date, setDate] = useState("");
    const [users, setUsers] = useState('');
    const [tema, setTema] = useState('');
    const [comment, setComment] = useState('');
    const [subject, setSubject] = useState('physical');
    const { tg } = useTelegram();

    const [open, setOpen] = React.useState(false);
    const [openDel, setOpenDel] = React.useState(false);

    const [openContr, setOpenContr] = React.useState(false);
    const [openContrDel, setOpenContrDel] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = (value) => {
        setOpen(false);
    };
    const handleClickOpenDel = () => {
        setOpenDel(true);
    };
    const handleCloseDel = (value) => {
        setOpenDel(false);
    };

    const handleClickOpenContr = () => {
        setOpenContr(true);
    };
    const handleCloseContr = (value) => {
        setOpenContr(false);
    };
    const handleClickOpenDelContr = () => {
        setOpenContrDel(true);
    };
    const handleCloseDelContr = (value) => {
        setOpenContrDel(false);
    };

    const handleChange = (event) => {
        setObject(event.target.value);
    };

    const AddressFetch = async () => {
        const url = 'https://apiregister.r4s-feeds.ru/api/objects/'
        let response = await fetch(url, {
            headers: {
                "Authorization": "ebrjvhberjvhbjkerhvsEDLIJj183762784",
            }
        });

        if (response.ok) {
            let json = await response.json();
            setObjectAll(json)
        } else {
            alert("Ошибка HTTP: " + response.status);
        }
    }
    const addObject = async () => {
        const urlAdd = 'https://apiregister.r4s-feeds.ru/api/register/'
        let response = await fetch(urlAdd, {
            method: 'POST',
            body: JSON.stringify({ name: objectNew }),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "ebrjvhberjvhbjkerhvsEDLIJj183762784",
            }
        });

        if (response.ok) {
            let json = await response.json();
            await AddressFetch()
            setOpen(false)

        } else {
            alert("Ошибка HTTP: " + response.status);
        }
    }
    const objectDel = async () => {
        const id = objectAll.filter(res => res.name === object)
        const urlAdd = `https://apiregister.r4s-feeds.ru/api/delete/${id[0].id}/`
        let response = await fetch(urlAdd, {
            method: 'DELETE',
            headers: {
                "Authorization": "ebrjvhberjvhbjkerhvsEDLIJj183762784",
            }
        });

        if (response.ok) {
            let json = await response.json();
            await AddressFetch()
            setObject('')
            setOpenDel(false)

        } else {
            alert("Ошибка HTTP: " + response.status);
        }
    }

    const ContrFetch = async () => {
        const url = 'https://apiregister.r4s-feeds.ru/api/objects-contr/'
        let response = await fetch(url, {
            headers: {
                "Authorization": "ebrjvhberjvhbjkerhvsEDLIJj183762784",
            }
        });

        if (response.ok) {
            let json = await response.json();
            setContractAll(json)
        } else {
            alert("Ошибка HTTP: " + response.status);
        }
    }
    const addObjectContr = async () => {
        const urlAdd = 'https://apiregister.r4s-feeds.ru/api/register-contr/'
        let response = await fetch(urlAdd, {
            method: 'POST',
            body: JSON.stringify({ name: contractNew }),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "ebrjvhberjvhbjkerhvsEDLIJj183762784",
            }
        });

        if (response.ok) {
            let json = await response.json();
            await ContrFetch()
            setOpenContr(false)

        } else {
            alert("Ошибка HTTP: " + response.status);
        }
    }
    const objectDelContr = async () => {
        const id = objectAll.filter(res => res.name === object)
        const urlAdd = `https://apiregister.r4s-feeds.ru/api/delete-contr/${id[0].id}/`
        let response = await fetch(urlAdd, {
            method: 'DELETE',
            headers: {
                "Authorization": "ebrjvhberjvhbjkerhvsEDLIJj183762784",
            }
        });

        if (response.ok) {
            let json = await response.json();
            await ContrFetch()
            setContract('')
            setOpenContrDel(false)

        } else {
            alert("Ошибка HTTP: " + response.status);
        }
    }


    useEffect(() => {
        const dd = new Date();
        const dd2 = dd.toISOString()
        const dd3 = dd2.split('.')
        console.log(dd3[0])
        AddressFetch()
        ContrFetch()
        setDate(dd3[0])
    }, [])

    const onSendData = useCallback(() => {
        const data = {
            date: new Date(date).toLocaleString('ru-RU'),
            object,
            contract,
            users,
            tema,
            comment
        }
        tg.sendData(JSON.stringify(data));
    }, [date, object, contract, users, tema, comment])

    useEffect(() => {
        tg.onEvent('mainButtonClicked', onSendData)
        return () => {
            tg.offEvent('mainButtonClicked', onSendData)
        }
    }, [onSendData])

    useEffect(() => {
        tg.MainButton.setParams({
            text: 'Отправить данные'
        })
    }, [])

    useEffect(() => {
        if (!date || !object || !contract || !users || !tema || !comment) {
            tg.MainButton.hide();
        } else {
            tg.MainButton.show();
        }
    }, [date, object, contract, users, tema, comment])

    const onChangeObject = (e) => {
        setObject(e.target.value)
    }

    const onChangeContract = (e) => {
        setContract(e.target.value)
    }
    const onChangeUsers = (e) => {
        setUsers(e.target.value)
    }
    const onChangeTema = (e) => {
        setTema(e.target.value)
    }
    const onChangeComment = (e) => {
        setComment(e.target.value)
    }

    const onChangeSubject = (e) => {
        setSubject(e.target.value)
    }
    const onChangeDate = (e) => {

        setDate(e.target.value)
    }

    return (
        <div className={"form"}>
            <h3 style={{ color: 'gray' }}>Введите ваши данные</h3>
            <TextField
                fullWidth
                value={date}
                position="start"
                variant="outlined"
                id="datetime-local"
                label="Дата, время"
                type="datetime-local"
                onChange={onChangeDate}
                sx={{ mt: 2, }}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            <Box sx={{ minWidth: 120, mt: 2, display: 'flex', flexDirection: 'row', alignItems: "center" }}>
                <Autocomplete
                    noOptionsText={'Список пуст'}
                    disablePortal
                    fullWidth
                    value={object}
                    onChange={(event, newValue) => {
                        setObject(newValue);
                    }}
                    options={objectAll.map((option) => option.name)}
                    sx={{ minWidth: 120 }}
                    renderInput={(params) => <TextField {...params} label="Объект" />}
                />
                <Button sx={{ minWidth: 20, marginLeft: 1 }} onClick={handleClickOpen}>
                    <AddCircleOutlineIcon sx={{ fontSize: 20 }} />
                </Button>
                {object != "" ?
                    <Button sx={{ minWidth: 20 }} onClick={handleClickOpenDel}>
                        <DeleteIcon sx={{ fontSize: 20, color: 'red' }} />
                    </Button> : ""}
            </Box>


            <Box sx={{ minWidth: 120, mt: 2, display: 'flex', flexDirection: 'row', alignItems: "center" }}>
                <Autocomplete
                    noOptionsText={'Список пуст'}
                    disablePortal
                    fullWidth
                    value={contract}
                    onChange={(event, newValue) => {
                        setContract(newValue);
                    }}
                    options={contractAll.map((option) => option.name)}
                    sx={{ minWidth: 120 }}
                    renderInput={(params) => <TextField {...params} label="Контрагент" />}
                />
                <Button sx={{ minWidth: 20, marginLeft: 1 }} onClick={handleClickOpenContr}>
                    <AddCircleOutlineIcon sx={{ fontSize: 20 }} />
                </Button>
                {contract != "" ?
                    <Button sx={{ minWidth: 20 }} onClick={handleClickOpenDelContr}>
                        <DeleteIcon sx={{ fontSize: 20, color: 'red' }} />
                    </Button> : ""}
            </Box>

            {/* <Box sx={{ minWidth: 120, mt: 2 }}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Контрагент</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={contract}
                        label="Контрагент"
                        onChange={onChangeContract}
                        sx={{ backgroundColor: 'white' }}
                    >
                        <MenuItem value={'ООО "ХОМЯЧКИ"'}>ООО "ХОМЯЧКИ"</MenuItem>
                        <MenuItem value={'ООО "ПАНЬКИ"'}>ООО "ПАНЬКИ"</MenuItem>
                        <MenuItem value={'ООО "ЧИХ-ПЫХ"'}>ООО "ЧИХ-ПЫХ"</MenuItem>
                        <MenuItem value={'ООО "КОТ ДА ВИНЧИ"'}>ООО "КОТ ДА ВИНЧИ"</MenuItem>
                    </Select>
                </FormControl>
            </Box> */}
            <textarea
                className={'input'}
                type="text"
                placeholder={'Состав участников'}
                value={users}
                onChange={onChangeUsers}
            />
            <textarea
                className={'input'}
                type="text"
                placeholder={'⁠⁠Тема встречи'}
                value={tema}
                onChange={onChangeTema}
            />
            <textarea
                className={'input'}
                type="text"
                placeholder={'⁠Комментарий'}
                value={comment}
                onChange={onChangeComment}
            />


            <Dialog onClose={handleClose} open={open} sx={{ width: '100%', }}>
                <DialogTitle>Добавьте объект</DialogTitle>
                <Box sx={{ width: '100%' }}>
                    <TextField id="outlined-basic" label="Объект" variant="outlined" fullWidth sx={{ width: 320, margin: "20px" }}
                        onChange={(event) => { setObjectNew(event.target.value); }} />
                </Box>
                <Button variant="contained" sx={{ margin: "20px" }} onClick={addObject}>Отправить</Button>
            </Dialog>

            <Dialog onClose={handleCloseDel} open={openDel} sx={{ width: '100%', }}>
                <DialogTitle>Вы точно хотите удалить объект?</DialogTitle>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'center' }}>
                    <Button variant="contained" sx={{ margin: "20px" }} onClick={handleCloseDel}>Отменить</Button>
                    <Button variant="contained" sx={{ margin: "20px" }} onClick={objectDel} color="error">Удалить</Button>
                </Box>
            </Dialog>


            <Dialog onClose={handleCloseContr} open={openContr} sx={{ width: '100%', }}>
                <DialogTitle>Добавьте контрагента</DialogTitle>
                <Box sx={{ width: '100%' }}>
                    <TextField id="outlined-basic" label="Контрагент" variant="outlined" fullWidth sx={{ width: 320, margin: "20px" }}
                        onChange={(event) => { setContractNew(event.target.value); }} />
                </Box>
                <Button variant="contained" sx={{ margin: "20px" }} onClick={addObjectContr}>Отправить</Button>
            </Dialog>

            <Dialog onClose={handleCloseDelContr} open={openContrDel} sx={{ width: '100%', }}>
                <DialogTitle>Вы точно хотите удалить контрагента?</DialogTitle>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'center' }}>
                    <Button variant="contained" sx={{ margin: "20px" }} onClick={handleCloseDelContr}>Отменить</Button>
                    <Button variant="contained" sx={{ margin: "20px" }} onClick={objectDelContr} color="error">Удалить</Button>
                </Box>
            </Dialog>


        </div>
    );
};

export default Form;
